import { execaCommand } from 'execa';
import type { Options } from './types.js';

export async function runCommand(command: string, opts?: Options) {
  const commandProcess = execaCommand(command, {
    /**
     * DO NOT USE `shell: true`!
     * It's a security risk that leads to injections and should be avoided.
     * ref: https://github.com/sindresorhus/execa/tree/main#shell
     */
    shell: false,
    cwd: opts?.cwd,
    env: opts?.env,
  });

  if (opts?.output) {
    commandProcess.stdout?.pipe(opts.output);
  }

  const { stdout } = await commandProcess;

  return stdout;
}
